import React, { useEffect, useRef, useState } from 'react';
import { Col, Offcanvas, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import {
  useGetRankHistoryFuncMutation,
  useGetRankHistoryQuery
} from '@/app/KeywordTracker/api/keywordsApi';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import AgGridSkeleton from '@/app/common/components/skeleton/AgGridSkeleton';
import { keywordsColumnConfig } from '@/app/KeywordTracker/config/keywordsColumnConfig';
import { rankHistoryColumnConfig } from '@/app/KeywordTracker/config/rankHistoryColumnConfig';
import AgGridWrapperTracker from '@/app/common/components/ag-grid/AgGridWrapperTracker';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';
import { hideDrawer } from '@/app/common/reducers/drawer';
const RanksHistoryDrawer = () => {
  const { data: userInfo } = useGetUserInfoQuery();
  const dispatch = useDispatch();
  const { key, payload } = useSelector(state => state.drawer);
  const { keyword_id, keyword } = payload ?? '';
  const { data, isError, isLoading, isFetching } = useGetRankHistoryQuery(
    {
      page: 1,
      perPage: 50,
      keyword_id
    },
    { skip: !keyword_id || !keyword || key !== 'rank_history' }
  );
  const [getRankHistoryFunc] = useGetRankHistoryFuncMutation();
  const gridRef = useRef(null);
  return (
    <DrawerWrapper
      show={key === 'rank_history'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0">
            سابقه رتبه در کلمه (
            <strong>{keyword ? decodeURIComponent(keyword) : ''}</strong>)
          </h6>
        </div>
      }
    >
      <Row className="mt-2 g-2">
        <Col>
          {!isFetching ? (
            <div ref={gridRef}>
              <AgGridWrapper
                settings={{
                  pagination: true,
                  fullscreen: false,
                  changeHeight: false,
                  resetGrid: false,
                  saveGrid: false
                  // export: {
                  // enabled: true,
                  // fetchFunction: exportTable,
                  //   additionalData: { domain_slug }
                  // }
                }}
                columns={rankHistoryColumnConfig}
                total={data?.data?.total}
                additionalData={{
                  keyword_id
                  //   domain_slug
                }}
                data={data?.data?.rows}
                height="746px"
                fetchFunction={getRankHistoryFunc}
                // data={fakeDataGen}
              />
            </div>
          ) : (
            <AgGridSkeleton
              height="696px"
              settings={{
                pagination: false,
                fullscreen: false,
                changeHeight: false,
                resetGrid: false,
                saveGrid: false,
                exportBtn: false
              }}
            />
          )}
        </Col>
      </Row>
    </DrawerWrapper>
  );
};

export default RanksHistoryDrawer;
